import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClockRotateLeft } from "@nnr/fontawesome-sharp-light/icons/sharp/light";
import { useChatsData } from "../../data/use-chats-data";
import { useGroupUuid } from "../../hooks/use-group-uuid";
import { useKitUuid } from "../../hooks/use-kit-uuid";
import { cn } from "../../lib/utils";
import { Badge } from "../ui/badge";
import { Button } from "../ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { Tooltip, TooltipContent, TooltipTrigger } from "../ui/tooltip";
import { useAssistContext } from "./AssistContext";

export const AssistChatHistoryDropdown = () => {
  const { setActiveChatUuid } = useAssistContext();
  const kitUuid = useKitUuid();
  const groupUuid = useGroupUuid();
  const { chats } = useChatsData(groupUuid, kitUuid);

  if (chats.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-row items-center gap-1">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" className="shrink-0">
            <Tooltip>
              <TooltipTrigger className="cursor-pointer space-x-2">
                <FontAwesomeIcon icon={faClockRotateLeft} />
                <Badge variant="outline" className="text-xs">
                  {chats.length}
                </Badge>
              </TooltipTrigger>
              <TooltipContent>Previous Chats</TooltipContent>
            </Tooltip>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="max-h-72">
          <DropdownMenuGroup>
            {chats.map((chat) => (
              <DropdownMenuItem
                className="cursor-pointer"
                key={chat.uuid}
                onClick={() => setActiveChatUuid(chat.uuid)}
              >
                {chat.name}
              </DropdownMenuItem>
            ))}
          </DropdownMenuGroup>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export const AssistChatHistoryList: React.FC = () => {
  const { activeChatUuid, setActiveChatUuid } = useAssistContext();
  const kitUuid = useKitUuid();
  const groupUuid = useGroupUuid();
  const { chats } = useChatsData(groupUuid, kitUuid);

  return (
    <div className="border-foreground-3 flex h-full flex-col gap-1 overflow-hidden border-r">
      <div className="flex grow-0 flex-row gap-2 p-2 text-xs font-semibold">
        <span>Previous Chats</span>
        <Badge variant="outline">{chats.length}</Badge>
      </div>
      <div className="w-full flex-1 overflow-y-auto px-2">
        {chats.length > 0 &&
          chats.map((chat) => (
            <Button
              variant="ghost"
              size="sm"
              className={cn("mb-1 w-full justify-start truncate rounded-sm", {
                "bg-sidebar-accent": chat.uuid === activeChatUuid,
              })}
              key={chat.uuid}
              onClick={() => setActiveChatUuid(chat.uuid)}
            >
              {chat.name}
            </Button>
          ))}
      </div>
    </div>
  );
};
